module.exports = __webpack_public_path__ + "media/images/giphy_attribution_black-87aa7cd5d645d0fae8b7224cc9a0ca00.png";